// Includes Countly SDK WEB
// https://support.count.ly/hc/en-us/articles/360037442892-NodeJS
const Countly = require('countly-sdk-web')
export default Countly
